import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.public.user-accounts.import.result', {
        url: '/result',
        params: {importResult: null},
        onEnter,
    });
}

/** @ngInject */
function onEnter($state, $uibModal) {
    $uibModal
        .open({component: 'userPasswordManagerImportResult'}).result
        .catch(() => $state.go('user.public.user-accounts', {}, {reload: true}));
}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/import/import-result/import-result.state.js